module.exports = __webpack_public_path__ + "fonts/loading-error.svg";